import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ObtenerPrioridades } from '../../helpers/AsuntosHelper';
import { GuardarPrioridad } from '../../helpers/PrioridadesHelper';
import { GuardarNuevoTipoServicio } from '../../helpers/ServiciosHelper';
import { PrioridadesContext } from '../../pages/catalogos/PrioridadesPage';
import { TiposServicioContext } from '../../pages/catalogos/ServiciosTipoPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregaPrioridadComponent = () => {
    const {modalAgregaPrioridad, setModalAgregaPrioridad, obtenerPrioridades, prioridadSel} = useContext(PrioridadesContext);
    const [prioridad, setPrioridad] = useState();
    const [errorGuardado, setErrorGuardado] = useState(false);
    const [idPrioridad, setIdPrioridad] = useState(0);
    const refForm = useRef();
    console.log('Valor de modal agrega', modalAgregaPrioridad);


    const verificaAccion = () => {
    if(prioridadSel?.IdPrioridad) {
        console.log('Esta editando', prioridadSel);
        setIdPrioridad(prioridadSel.IdPrioridad);
        setPrioridad(prioridadSel.Prioridad);
      } else {
        console.log('esta agregando', prioridadSel);
        setPrioridad('');
        setIdPrioridad(0);
      }
    }

    useEffect(() => {
      verificaAccion();
    }, [prioridadSel])
    

    const handleClose = () => {
        setModalAgregaPrioridad(false);
    }

    const handleSubmit =  (event) => {
        event.preventDefault();
       // refForm.current.isValidate();
        GuardarPrioridad(prioridad, idPrioridad).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerPrioridades();
                handleClose();

            }
        })
    }

  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalAgregaPrioridad} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>Prioridad</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="txtTipoServicio"
            label="Prioridad"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => setPrioridad(e.target.value)}
            value={prioridad}
          />
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
